import { render, staticRenderFns } from "./accessories.vue?vue&type=template&id=46261d88&scoped=true&"
import script from "./accessories.vue?vue&type=script&lang=js&"
export * from "./accessories.vue?vue&type=script&lang=js&"
import style0 from "./accessories.vue?vue&type=style&index=0&id=46261d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46261d88",
  null
  
)

export default component.exports